import React from "react";
import BranchIndexPage from "../features/branch/page/branch-index-page";
import TransportVehicleIndexPage from "../features/transport-vehicle/page/transport-vehicle-index-page";
import { DashboardPage } from "../features/dashboard/page/dashboard-page";
import DepartmentIndexPage from "../features/department/page/department-index-page";
import POSPage from "../features/order/page/order-index-pos-page";
import CreateOrderPage from "../features/order/page/create-order-page";
import ServiceAddonIndexPage from "../features/service-addon/page/service-addon-index-page";
import ServiceMapIndexPage from "../features/service-map/page/service-map-index-page";
import { ServiceTypeIndexPage } from "../features/service-type/page/service-type-index-page";
import ServiceIndexPage from "../features/service/page/service-index-page";
import SettingPage from "../features/setting/setting-page";
import UserIndexPage from "../features/user/page/user-index-page";
import { MODULE_ROUTE } from "./module-router";
import ProfilePage from "../features/auth/page/profile-page";
import ChangePasswordPage from "../features/auth/page/change-password-page";
import OrderListPage from "../features/order-list/page/order-index-page";
import CustomerListPage from "../features/customer/page/customer-index-page";
import DriverListPage from "../features/driver/page/driver-index-page";

import PermissionEmployeeIndexPage from "../features/permission-employee/page/permission-employee-index-page";
import PermissionDepartmentIndexPage from "../features/permission-department/page/permission-deparment-index-page";

import PrivilegeGroupIndexPage from "../features/privilege/pages/privilege-group-index-page";
import ReceiptCategoriesIndexPage from "../features/receipt-categories/pages/receipt-categories-index-page";
import ReceiptIndexPage from "../features/receipt/pages/receipt-index-page";
import AccountingAccountIndexPage from "../features/accounting-account/pages/accounting-account-index-page";
import ShiftIndexPage from "../features/shift/page/shift-index-page";
import ShiftAssignmentIndexPage from "../features/shift-assignment/page/shift-assignment-index-page";
import SettingPaymentIndexPage from "../features/setting-payment-method/page/setting-payment-index-page";
import SettingDriverPage from "../features/setting-driver/page/setting-driver-index-page";
import AttendanceManagementPage from "../features/human-resources/attendance/page/attendance-management-page";
import AttendancePersonalPage from "../features/human-resources/attendance-personal/page/attendance-personal-page";

// Reports
import { ExecutiveDashboard } from "../features/reports/pages/executive";
import { SalesDashboard } from "../features/reports/pages/sales";
import { OperationsDashboard } from "../features/reports/pages/operations";
import { FinanceDashboard } from "../features/reports/pages/finance";
import { MarketingDashboard } from "../features/reports/pages/marketing";

// Equipment & Branch Settings & Clothing Categories
import EquipmentIndexPage from "../features/equipment/page/equipment-index-page";
import BranchSettingsIndexPage from "../features/branch-settings/page/branch-settings-index-page";
import ClothingCategoriesIndexPage from "../features/clothing-categories/page/clothing-categories-index-page";
import UnitsIndexPage from "../features/units/page/units-index-page";

// New features
import CustomerPricingIndexPage from "../features/customer-pricing/page/customer-pricing-index-page";
import WageRatesIndexPage from "../features/employee-wage-rates/page/wage-rates-index-page";
import DriverCashLedgerIndexPage from "../features/driver-cash-ledger/page/driver-cash-ledger-index-page";
import RecurringOrdersIndexPage from "../features/recurring-orders/page/recurring-orders-index-page";
import EmployeeKgReportPage from "../features/order-list/page/employee-kg-report-page";
import FaultTicketReportPage from "../features/fault-ticket/page/fault-ticket-report-page";
import ReconciliationReportPage from "../features/reconciliation/page/reconciliation-report-page";
import ItemDebtOverviewPage from "../features/reconciliation/page/item-debt-overview-page";
import RewashReportPage from "../features/rewash-report/page/rewash-report-page";
import SalesOutputReportPage from "../features/sales-output-report/page/sales-output-report-page";
import CustomerDebtIndexPage from "../features/customer-debt/page/customer-debt-index-page";
import FaultTicketIndexPage from "../features/fault-ticket/page/fault-ticket-index-page";
import AdjustmentRequestIndexPage from "../features/adjustment-request/page/adjustment-request-index-page";
import BankTransferIndexPage from "../features/bank-transfer/page/bank-transfer-index-page";

export const dashboardRouter = [
  { path: MODULE_ROUTE.DASHBOARD, component: <DashboardPage /> },
  { path: MODULE_ROUTE.SETTING, component: <SettingPage /> },
  { path: MODULE_ROUTE.SERVICE_TYPE_LIST, component: <ServiceTypeIndexPage /> },
  { path: MODULE_ROUTE.SERVICES_LIST, component: <ServiceIndexPage /> },
  { path: MODULE_ROUTE.SERVICE_MAP_LIST, component: <ServiceMapIndexPage /> },
  {
    path: MODULE_ROUTE.SERVICE_ADDON_LIST,
    component: <ServiceAddonIndexPage />,
  },
  { path: MODULE_ROUTE.POS_ORDER, component: <POSPage /> },
  { path: MODULE_ROUTE.CREATE_ORDER, component: <CreateOrderPage /> },
  { path: MODULE_ROUTE.ORDER, component: <OrderListPage /> },
  { path: MODULE_ROUTE.BRANCH, component: <BranchIndexPage /> },
  { path: MODULE_ROUTE.TRANSPORT_VEHICLE, component: <TransportVehicleIndexPage /> },
  { path: MODULE_ROUTE.USER, component: <UserIndexPage /> },
  { path: MODULE_ROUTE.DEPARTMENT, component: <DepartmentIndexPage /> },
  {path: MODULE_ROUTE.PROFILE, component: <ProfilePage />},
  {path: MODULE_ROUTE.CHANGE_PASSWORD, component: <ChangePasswordPage />},
  {path: MODULE_ROUTE.CUSTOMER, component: <CustomerListPage />},
  {path: MODULE_ROUTE.DRIVER, component: <DriverListPage />},

  {path: MODULE_ROUTE.PERMISSION_EMPLOYEE, component: <PermissionEmployeeIndexPage />},
  {path: MODULE_ROUTE.PERMISSION_DEPARTMENT, component: <PermissionDepartmentIndexPage />},

  

  {path: MODULE_ROUTE.PRIVILEGE, component: <PrivilegeGroupIndexPage />},
  {path: MODULE_ROUTE.RECEIPT_CATEGORY, component: <ReceiptCategoriesIndexPage />},
  {path: MODULE_ROUTE.RECEIPT, component: <ReceiptIndexPage />}  ,
  {path: MODULE_ROUTE.ACCOUNTING_ACCOUNT, component: <AccountingAccountIndexPage />}, 

  {path: MODULE_ROUTE.SHIFT, component: <ShiftIndexPage />},
  {path: MODULE_ROUTE.SHIFT_ASSIGNMENT, component: <ShiftAssignmentIndexPage />},
  {path: MODULE_ROUTE.SETTING_PAYMENT_METHOD, component: <SettingPaymentIndexPage />},
  {path: MODULE_ROUTE.SETTING_DRIVER, component: <SettingDriverPage />},
  {path: MODULE_ROUTE.ATTENDANCE_MANAGEMENT, component: < AttendanceManagementPage/>},
  {path: MODULE_ROUTE.ATTENDANCE_PERSONAL, component: < AttendancePersonalPage/>},

  // Reports
  {path: MODULE_ROUTE.REPORT_EXECUTIVE, component: <ExecutiveDashboard />},
  {path: MODULE_ROUTE.REPORT_SALES, component: <SalesDashboard />},
  {path: MODULE_ROUTE.REPORT_OPERATIONS, component: <OperationsDashboard />},
  {path: MODULE_ROUTE.REPORT_FINANCE, component: <FinanceDashboard />},
  {path: MODULE_ROUTE.REPORT_MARKETING, component: <MarketingDashboard />},
  {path: MODULE_ROUTE.EMPLOYEE_KG_REPORT, component: <EmployeeKgReportPage />},
  {path: MODULE_ROUTE.FAULT_TICKET_REPORT, component: <FaultTicketReportPage />},
  {path: MODULE_ROUTE.RECONCILIATION_REPORT, component: <ReconciliationReportPage />},
  {path: MODULE_ROUTE.ITEM_DEBT_OVERVIEW_REPORT, component: <ItemDebtOverviewPage />},
  {path: MODULE_ROUTE.REWASH_REPORT, component: <RewashReportPage />},
  {path: MODULE_ROUTE.SALES_OUTPUT_REPORT, component: <SalesOutputReportPage />},

  // Equipment & Branch Settings & Clothing Categories
  {path: MODULE_ROUTE.EQUIPMENT, component: <EquipmentIndexPage />},
  {path: MODULE_ROUTE.BRANCH_SETTINGS, component: <BranchSettingsIndexPage />},
  {path: MODULE_ROUTE.CLOTHING_CATEGORIES, component: <ClothingCategoriesIndexPage />},
  {path: MODULE_ROUTE.UNITS, component: <UnitsIndexPage />},

  // New features
  {path: MODULE_ROUTE.CUSTOMER_PRICING, component: <CustomerPricingIndexPage />},
  {path: MODULE_ROUTE.WAGE_RATES, component: <WageRatesIndexPage />},
  {path: MODULE_ROUTE.DRIVER_CASH_LEDGER, component: <DriverCashLedgerIndexPage />},
  {path: MODULE_ROUTE.RECURRING_ORDERS, component: <RecurringOrdersIndexPage />},
  {path: MODULE_ROUTE.CUSTOMER_DEBT, component: <CustomerDebtIndexPage />},
  {path: MODULE_ROUTE.BANK_TRANSFER, component: <BankTransferIndexPage />},
  {path: MODULE_ROUTE.FAULT_TICKET, component: <FaultTicketIndexPage />},
  {path: MODULE_ROUTE.ADJUSTMENT_REQUEST, component: <AdjustmentRequestIndexPage />},
];
